import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    FormHelperText, Grid, List, ListItem, ListItemText,
    MenuItem, Slide, Typography
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import { StateContext, DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ParticipantModalForm = (props) => {
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalState, facultyState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [customErrorMessage, setCustomErrorMessage] = useState(null);
    const [participant, setParticipant] = useState({
        email_lrn: ''
    });

    async function addParticipant(values, resetForm) {

        const res = await axiosConfig.post(`/participants`, {
            classcode: props.classcode,
            email_lrn: values.email_lrn
        });

        if (res.data.status_code == 'ok') {
            console.log(res.data);
            globalDispatch({type: 'setSnackbarMsg', value: 'Participant enrolled successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});
            props.handleClose();
            props.fetchParticipants();
        } else {
            console.log(res);
            setCustomErrorMessage(res.data.message);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={'sm'}
                TransitionComponent={Transition}
                disableBackdropClick
            >
                <Formik
                    initialValues={participant}
                    validate={(values) => {
                        const errors = {};
                        if (!values.email_lrn) {
                            errors.email_lrn = 'This field is required';
                        }

                        return errors;
                    }}
                    onSubmit={(values, {setSubmitting, resetForm}) => {
                        setSubmitting(false);
                        globalDispatch({type: 'setIsLoading', value: true});
                        addParticipant(values, resetForm);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors}) => (
                        <Form>
                            <DialogTitle id="form-dialog-title">
                                {props.dialogTitle}
                            </DialogTitle>
                            <DialogContent>
                                <Grid container alignItems="flex-start" spacing={2}>
                                    {customErrorMessage && (
                                        <Grid item xs={12}>
                                            <Alert variant="filled" severity="error" style={{width: '100%'}}>
                                                <Typography>
                                                    {customErrorMessage}
                                                </Typography>
                                            </Alert>
                                        </Grid>
                                    )}

                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Student Email / LRN (required)"
                                            name="email_lrn"
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={props.handleClose}
                                    disabled={isSubmitting}
                                    color="secondary"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    onClick={submitForm} color="primary"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
}

export default ParticipantModalForm;